"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useModalInternalContext = exports.ModalInternalProvider = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _utils = require("../HBBanner/utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ModalContext = /*#__PURE__*/(0, _react.createContext)(null);
var ModalInternalProvider = exports.ModalInternalProvider = ModalContext.Provider;
var useModalInternalContext = exports.useModalInternalContext = function useModalInternalContext() {
  var props = (0, _react.useContext)(ModalContext);
  return _objectSpread(_objectSpread({}, props), {}, {
    getTestIdProps: function getTestIdProps(suffix) {
      return (0, _utils.getTestIdProps)(_objectSpread(_objectSpread({}, props), {}, {
        suffix: suffix
      }));
    }
  });
};
//# sourceMappingURL=ModalInternalContext.js.map